"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _dynamictable_styles = _interopRequireDefault(require("./dynamictable_styles"));

var _dynamictable_definition = _interopRequireDefault(require("./dynamictable_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
//material
// styles
// definition

/* ++++++++++ --------------- EXPORT : DYNAMIC TABLE --------------- ++++++++++ */


var DynamicTable = (0, _reactJss.default)(_dynamictable_styles.default)(function (props) {
  var renderTableHeads = function renderTableHeads() {
    return _react.default.createElement("tr", null, props.headers.map(function (header) {
      return _react.default.createElement("th", {
        align: 'left',
        valign: 'top',
        onClick: header.action,
        className: "".concat(header.value, " sort-").concat(header.sort)
      }, header.text, renderSortIcon(header));
    }));
  };

  var renderSortIcon = function renderSortIcon(header) {
    return header.sort ? _react.default.createElement(_index.Icon, {
      name: "sort-".concat(header.sorted ? 'down' : 'up')
    }) : null;
  };

  var renderTableBody = function renderTableBody() {
    return props.data && !!props.data.length ? props.data.map(function (blob) {
      return renderRow(blob);
    }) : _react.default.createElement("tr", {
      className: 'nodata'
    }, _react.default.createElement("td", {
      colspan: "10"
    }, "No Data"));
  };

  var renderRow = function renderRow(blob) {
    if (blob.subRowData) {
      return subRowLogic(blob);
    } else {
      return rowLogic(blob);
    }
  };

  var rowLogic = function rowLogic(blob) {
    return _react.default.createElement("tr", null, props.headers.map(function (head) {
      return _react.default.createElement("td", {
        className: head.value
      }, blob[head.value]);
    }));
  };

  var subRowLogic = function subRowLogic(blob) {
    return blob.subRowData.map(function (row, index) {
      return index === 0 ? _react.default.createElement("tr", {
        className: "mainRow flagged-".concat(!!blob.subRowData[index].flag)
      }, props.headers.map(function (head) {
        return !props.subHeaderValues.includes(head.value) ? _react.default.createElement("td", {
          className: head.value,
          rowSpan: blob.subRowData.length
        }, blob[head.value]) : _react.default.createElement("td", {
          className: head.value
        }, blob.subRowData[index][head.value]);
      })) : _react.default.createElement("tr", {
        className: "subRows flagged-".concat(!!blob.subRowData[index].flag)
      }, Object.keys(blob.subRowData[index]).map(function (subRowCell) {
        return _react.default.createElement("td", {
          className: subRowCell
        }, blob.subRowData[index][subRowCell]);
      }));
    });
  };

  return _react.default.createElement("div", {
    className: "table dynamictable ".concat(props.classes.dynamictable)
  }, _react.default.createElement("table", {
    className: 'tableelement'
  }, _react.default.createElement("thead", null, renderTableHeads()), _react.default.createElement("tbody", null, renderTableBody())));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(DynamicTable, _dynamictable_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = DynamicTable;
exports.default = _default;